import React from 'react'
import { useRouter } from 'next/router'
import { Rating } from 'react-simple-star-rating'
import { FaRegStar, FaStar } from 'react-icons/fa'

import FormSteps from 'src/components/formSteps'
import { Radio } from 'src/components/forms'
import WarningModal from 'src/components/warningModal'
import PageContainer from 'src/components/pageContainer'
import ProfessionalInfoModal from 'src/components/professionalInfoModal'
import SchedulingInfo from 'src/components/schedulingSteps/schedulingInfo'

import { useProfessionalContext } from 'src/context/professionalContext'
import { useServiceScheduleContext } from 'src/context/serviceScheduleContext'

import { assetPrefix } from 'config/env_config'
import withRootContext from 'context/withRootContextHOC'

import { isMobile } from 'src/utils'

import * as S from './styles'
import * as Gs from 'src/styles/global'

const ProfessionalStep = (props) => {
  const { context } = props
  // Adaptação as antigas funções
  const router = useRouter()
  const { state: schedulingState, functions: schedulingFunctions } = useServiceScheduleContext()
  const { functions } = useProfessionalContext()

  const {
    professionalData,
    scheduleBody,
    noPreference,
    selectedPetSchedule,
    modal,
    invertStep
  } = schedulingState

  const {
    handleNoPreferenceProfessional,
    handleViewProfessional,
    handleSelectedProfessional
  } = functions

  const {
    handleWarningModalClose
  } = schedulingFunctions

  const isProfessionalFlow = invertStep === false

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps context={context}>
        <S.PageContainer>
          <Gs.WrapperFormAndCard>
            <S.AlignWrappers>
              <S.WrapperTitle>
                <span>Selecione o profissional</span>
              </S.WrapperTitle>

              <S.WrapperElements>
                <>
                  {!isMobile() && scheduleBody?.samePetDate && (
                    <S.Warning>
                      <img src={assetPrefix + '/static/icons/info-circle.svg'} />
                      Profissionais disponíveis para o mesmo dia e horário agendado para {selectedPetSchedule?.name}
                    </S.Warning>
                  )}

                  {!isProfessionalFlow && (
                    <S.Card active={noPreference} onClick={() => { handleNoPreferenceProfessional({ context }) }}>
                      <S.CardBody>
                        <S.ProfessionalPhoto>
                          <img src={`${assetPrefix}/static/icons/no-professional-preferably.svg`} />
                        </S.ProfessionalPhoto>
                        <S.CardContent>
                          <S.PartnerBody>
                            <S.SpanProfessional>
                              <span>Sem profissional de preferência</span>
                            </S.SpanProfessional>
                          </S.PartnerBody>
                        </S.CardContent>
                        <div>
                          <Radio
                            dataTest='radio-professional-no-preference'
                            value={scheduleBody.professional_id}
                            name='professional-radio'
                            id='radio-no-preference'
                            defaultChecked={noPreference}
                          />
                        </div>
                      </S.CardBody>
                    </S.Card>
                  )}

                  {professionalData && professionalData.map(({ id, name, photo, ratingAverage }) => (
                    <S.Card
                      key={id}
                      id={`professional-${id}`}
                      onClick={() => { handleSelectedProfessional(id, { context, router }) }}
                      padding='16px'
                      active={scheduleBody.professional_id === id && !noPreference}
                    >
                      <S.CardBody>
                        <S.ProfessionalPhoto>
                          {photo
                            ? <img src={photo} />
                            : <img src={`${assetPrefix}/static/icons/avatar.svg`} />}
                        </S.ProfessionalPhoto>
                        <S.CardContent>
                          <S.PartnerBody>
                            <S.SpanProfessional>
                              <span>{name.split('CNPJ')[0]}</span>
                            </S.SpanProfessional>
                            <S.PartnerRating>
                              {ratingAverage && (
                                <Rating
                                  ratingValue={(ratingAverage * 20)}
                                  fillColor='var(--dark-yellow)'
                                  allowHalfIcon
                                  fullIcon={<FaStar size={16} color='var(--dark-yellow)' />}
                                  emptyIcon={<FaRegStar size={16} color='var(--dark-yellow)' />}
                                  readonly={ratingAverage > 0}
                                />
                              )}
                            </S.PartnerRating>
                            <S.LabelProfessional>
                              <label onClick={(e) => { handleViewProfessional(id, e) }}>Saber mais</label>
                            </S.LabelProfessional>
                          </S.PartnerBody>
                        </S.CardContent>

                        <S.WrapperRadio>
                          <Radio
                            dataTest={`radio-professional-${name.toLowerCase().replace(/\s/g, '-')}`}
                            value={scheduleBody.professional_id}
                            id={`radio-${id}`}
                            name='professional-radio'
                            defaultChecked={scheduleBody.professional_id === id && !noPreference}
                          />
                        </S.WrapperRadio>
                      </S.CardBody>
                    </S.Card>
                  ))}
                </>
              </S.WrapperElements>
            </S.AlignWrappers>
            <SchedulingInfo />
          </Gs.WrapperFormAndCard>
        </S.PageContainer>
      </FormSteps>
      {modal?.type === 'professionalInfo' ? (
        <ProfessionalInfoModal
          visible={!!modal}
          cancelLabel={modal.cancelLabel}
          confirmLabel={modal.confirmLabel}
          type={modal.type}
          title={modal.title}
          subtitle={modal.subtitle}
          // eslint-disable-next-line
          onConfirm={modal.onConfirm}
          onCancel={handleWarningModalClose}
          fullButton={modal.fullButton}
          showClose={modal.showClose}
          icon={modal.icon ? modal.icon : !modal.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
          iconSize={modal.iconSize}
          dataTest='modal-warning-scheduling'
        >
          {modal.body}
        </ProfessionalInfoModal>
      ) : (
        <WarningModal
          visible={!!modal}
          cancelLabel={modal?.cancelLabel}
          confirmLabel={modal?.confirmLabel}
          type={modal?.type}
          title={modal?.title}
          subtitle={modal?.subtitle}
          onConfirm={modal?.onConfirm}
          onCancel={handleWarningModalClose}
          fullButton={modal?.fullButton}
          showClose={modal?.showClose}
          icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
          iconSize={modal?.iconSize}
          dataTest='modal-warning-scheduling'
        >
          {modal?.body}
        </WarningModal>
      )}
    </PageContainer>
  )
}

export default withRootContext(ProfessionalStep)
